import { Entity } from '../../entities';

export interface HomesNSWNoticeContractorResponse {
    _id: string;
    contractorResponseDate: string;
    noticeResponseFromContractor: string;
    planOfAction: string;
    disputeComments: string;
}

export interface HomesNSWNoticeLahcDisputeResponse {
    _id: string;
    lahcAcceptsDispute: string;
    dateOfDisputeAcceptanceDecline: string;
    reasonForDecliningDispute: string;
}

export interface HomesNSWNoticeContractorDisputeResolution {
    _id: string;
    disputeResolutionToBeDone: string;
    dateOfDisputeResolution: string;
    disputeResolutionComments: string;
}

export interface HomesNSWNoticeLahcDisputeResolutionDetails {
    _id: string;
    disputeResolutionUpheldRejected: string;
}

export interface HomesNSWNoticeContractorActions {
    _id: string;
    remediedAsPerNotice: string;
    dateOfRemediation: string;
    remediationComments: string;
}

export interface HomesNSWNoticeLineItemAuditFindings {
    _id: string;
    auditFindingsRecommendations: string;
    details: string;
}

export interface HomesNSWNoticeLineItemAdditionalComments {
    _id: string;
    disputeComments: string;
    withdrawnComments: string;
    cancelledComments: string;
    shortDescription: string;
    longDescription: string;
}

export interface HomesNSWNoticeDetails extends Entity {
    lineItems: HomesNSWNoticeLineItem[];
    noticeType: string;
    noticeStatus: string;
    workOrderNumber: string;
    noticeIssuedDate: string;
    noticeEscalated: string;
    noticeId: string;
    contractor: string;
    contractorContactName: string;
    noticeCreatorContactNumber: string;
    noticeCategoryDetail: string;
    noticeResponseDueDate: string;
    noticeRemedyDueDate: string;
    noticeDescription: string;
    revisedNoticeRemedyDueDate: string;
    noticeReIssuedDate: string;
    noticeWithdrawnReason: string;
    contractorResponse: HomesNSWNoticeContractorResponse;
    lahcDisputeResponse: HomesNSWNoticeLahcDisputeResponse;
    contractorDisputeResolution: HomesNSWNoticeContractorDisputeResolution;
    lahcDisputeResolutionDetails: HomesNSWNoticeLahcDisputeResolutionDetails;
    contractorActions: HomesNSWNoticeContractorActions
}

export interface HomesNSWNoticeDetailsWithPreviousStatus extends HomesNSWNoticeDetails {
    previousStatus: string;
}

export interface HomesNSWNoticeLineItem extends Entity {
    noticeLineItemId: string;
    lineItemStatus: string;
    lineItemResponseFromContractor: string;
    serviceItemTenderedRateInclGst: string;
    totalCost: string;
    serviceItemCode: string;
    assessmentOutcome: string;
    serviceItemTenderedRateExclGst: string;
    totalCostExclGst: string;
    quantity: string;
    comments: string;
    auditFindings: HomesNSWNoticeLineItemAuditFindings;
    additionalComments: HomesNSWNoticeLineItemAdditionalComments;
};

export enum HomesNSWNoticeEntityFormAction {
    SubmitResponse = 'SubmitResponse',
    AcceptAll = 'AcceptAll',
    DisputeAll = 'DisputeAll',
    DisputeResolution = 'DisputeResolution',
    Remedied = 'Remedied',
}

export enum HomesNSWNoticeStatus {
    Issued = 'Issued',
    ReIssued = 'Re-Issued',
    RespondedByContractor = 'Responded by Contractor',
    ResponseReviewedByLAHC = 'Response Reviewed by LAHC',
    DisputeResolution = 'Dispute Resolution',
    Remedied = 'Remedied',
    Reinspection = 'Re-Inspection',
    Complete = 'Complete',
    Closed = 'Closed'
};

export enum HomesNSWNoticeLineItemContractorResponse {
    Accepted = 'Accepted',
    Disputed = 'Disputed',
    NoResponse = ''
}